export default {
  ApprovalStatus: {
    SUBMIT: '제출',
    RETRACT: '제출 취소',
    APPROVED: '승인',
    REJECT: '기각',
  },
  ConfigKey: {
    DEFAULT_AVATAR_PATH: '기본 아바타 경로',
    KRAMPUS_URL: 'KRAMPUS URL',
    ADMIN_HOST: '관리 화면 주소',
    MIN_DEPOSIT: '최소 입금 제한 (달러)',
    MIN_WITHDRAWAL: '최소 인출 제한 (달러)',
    UPLOAD_PATH: '시스템 루트 디렉터리에 파일 업로드 경로',
    FILE_PATH: '파일 업로드 하위 디렉터리',
    REGISTER_URL_BASE: '등록 URL BASE',
    JWT_VERSION_FRONT: 'JWT 프론트 버전',
    JWT_VERSION_ADMIN: 'JWT 관리자 버전',
    MAX_DEPOSIT: '최대 입금 금액 (달러)',
    MAX_WITHDRAWAL: '최대 출금 금액 (달러)',
    SENTRY_ENABLED: 'Sentry 활성화',
    SENTRY_URL: 'Sentry URL',
  },
  Currency: {
    USDT: 'USDT',
    BRL: '브라질 레알',
    INR: '인도 루피',
    USD: '미국 달러',
    EUR: '유로',
    HKD: '홍콩 달러',
    IDR: '인도네시아 루피',
    VND: '베트남 동',
  },
  CustomerField: {
    NAME: '이름',
    MOBILE: '휴대폰 번호',
    SEX: '성별',
    DOB: '생일',
    DISTRICT: '지역',
  },
  FlowChartType: {
    VERIFIED: '고객 인증 프로세스',
    DEPOSIT: '입금 처리 프로세스',
    WITHDRAWAL: '출금 처리 프로세스',
  },
  FlowInfoType: {
    VERIFIED: '고객 인증',
    DEPOSIT: '입금 처리',
    WITHDRAWAL: '출금 처리',
  },
  IdentificationType: {
    ID_CARD: '신분증',
    PASSPORT: '여권',
    DRIVER_LICENSE: '운전 면허증',
    SOCIAL_INSURANCE_CARD: '사회 보험 카드',
    OTHER: '기타',
  },
  ReceiveMethod: {
    BANK: '은행',
    USDT: 'USDT',
    NET_PAY: '순이익',
  },
  ResourceType: {
    ID: '신분 정보',
    CUSTOMER_AVATAR: '고객 프로필 사진',
    IT_RECEIVE_AVATAR: '기관 수신 정보',
    PROCESS_FLOW: '프로세스 흐름도',
    TRANSFER_PROOF: '이체 증명서',
  },
  Sex: {
    MALE: '남성',
    FEMALE: '여성',
    SECRET: '비공개',
  },
  TransferTransactionStatus: {
    TRANSFERRING: '이체 대기',
    TRANSFERRED: '이체 완료',
    CONFIRMED: '수금 완료',
    CANCELLED: '취소됨',
    FORCE_CONFIRMED: '수금 완료 (강제)',
    FORCE_CANCELLED: '취소됨 (강제)',
    FAILED: '실패한',
  },
  TransferRole: {
    CUSTOMER: '고객',
    IT: '기관',
  },
  DurationType: {
    MINUTES: '분',
    HOURS: '시간',
  },
  Lang: {
    AUTO: '자동',
    EN: '영어',
    ZH_CN: '중국어 (간체)',
    ZH_HK: '중국어 (번체)',
    JA: '일본어',
    KO: '한국어',
    PT: '포르투갈어',
    ID: '인도네시아어',
  },
  CryptoNetwork: {
    TRC20: 'TRC20',
    ERC20: 'ERC20',
  },
  RoleType: {
    SUPER_USER: '슈퍼 사용자',
    ROLE_IT: '기관 관리자',
    ROLE_AGENT: '에이전트 관리자',
  },
  Country: {
    SOUTH_KOREA: '한국',
    JAPAN: '일본',
    BRAZIL: '브라질',
    INDIA: '인도',
    TAIWAN: '대만',
    INDONESIA: '인도네시아 공화국',
    VIETNAM: '베트남',
  },
  QMaxInvestmentOption: {
    HKD_300000: '300,000달러',
    HKD_100: '100달러',
  },
  QTriggerOption: {
    AT_LATEST_PRICE: '최신 가격으로 포지션을 청산합니다',
    STOP_LOSS_NOT_TRIGGERED: '손절 주문이 포지션을 닫지 못했습니다',
  },
  AutoCloseOption: {
    INSUFFICIENT_CAPITAL: '시장이 내 포지션에 불리한 방향으로 진행되며 내 계정에 충분한 자본이 없습니다.',
    FAVORABLE_DIRECTION: '시장이 내 유리한 방향으로 전환 중입니다.',
  },
  QTradingCountOption: {
    COUNT_100: '51에서 100 거래',
    COUNT_50: '20에서 50 거래',
    COUNT_LESS_THAN_20: '20 거래 미만',
    COUNT_NONE: '거래 기록 없음',
  },
  QOtcLeverageOption: {
    BETWEEN_1_50_AND_1_100: '1:50 - 1:100 사이',
    BETWEEN_1_25_AND_1_50: '1:25 - 1:50 사이',
    BETWEEN_1_2_AND_1_25: '1:2 - 1:25 사이',
    NO_LEVERAGE: '레버리지 사용 안 함 (1:1)',
  },
  QFinanceEducationOption: {
    WORKED_IN_FINANCIAL: '금융 서비스 업계 근무 경험',
    PROFESSIONAL: '전문 자격증 또는 고등 교육',
  },
  QOccupationOption: {
    EMPLOYEE: '직장인',
    SELF_EMPLOYED: '자영업자',
    RETIRED: '은퇴자',
    STUDENT: '학생',
    PROPERTY: '부동산 소유자',
  },
  QIndustryOption: {
    FINANCIAL_SERVICES: '금융 서비스 업계',
    INFORMATION_TECHNOLOGY: '정보 기술 업계',
    HEALTHCARE: '의료 및 건강관리 업계',
    RETAIL_AND_CONSUMER_GOODS: '소매 및 소비재 업계',
    MANUFACTURING: '제조업',
    MEDIA_AND_ENTERTAINMENT: '미디어 및 엔터테인먼트 업계',
    CONSTRUCTION_AND_REAL_ESTATE: '건설 및 부동산 업계',
    ENERGY_AND_UTILITIES: '에너지 및 공공서비스 업계',
    CONSULTING_AND_PROFESSIONAL_SERVICES: '컨설팅 및 전문 서비스 업계',
    OTHER: '기타',
  },
  QFinancialAmountOption: {
    FIVE_M_PLUS: '5,000,000 달러 이상',
    FIVE_M: '2,000,000 - 5,000,000 달러',
    TWO_M: '1,000,000 - 2,000,000 달러',
    ONE_M: '500,000 - 1,000,000 달러',
    FIVE_HUNDRED_K: '200,000 - 500,000 달러',
    TWO_HUNDRED_K: '50,000 - 200,000 달러',
    FIFTY_K: '0 - 50,000 달러',
  },
  QIncomeSourceOption: {
    EMPLOYMENT_INCOME: '직업 소득',
    PENSION_OR_GOVERNMENT_BENEFITS: '연금 또는 정부 혜택',
    INVESTMENT_INCOME: '투자 수익',
    INHERITANCE: '상속',
    PROPERTY_SALE: '부동산 매매',
    BUSINESS_SALE: '사업 매매',
  },
  QTradingFrequencyOption: {
    DAILY: '매일',
    WEEKLY: '매주',
    MONTHLY: '매월',
  },
  QDepositMethodOption: {
    CREDIT_CARD: '신용카드/체크카드',
    BANK_TRANSFER: '은행 송금',
  },
  PaymentGateway: {
    PPAY: 'ppay 결제',
    CASH_PAY: 'cashpay 결제',
    UAT_EPAY: 'UAT epay 결제',
    PRO_EPAY: 'PRO epay 결제',
  },
  PayType: {
    RECEIVE: '입금',
    PAYMENT: '출금',
  },
  TransactionModel: {
    C2C: 'C2C',
    B2C: 'B2C',
    B2B: 'B2B',
    C2B: 'C2B',
  },
  TransactionCategory: {
    BANK: '은행',
    TRANSFER: '송금',
    IFSC: '인도 결제-IFSC',
    PIX: '브라질 결제-PIX',
  },
  FeeModel: {
    FIXED: '고정 수수료',
    PERCENTAGE: '퍼센트 수수료',
  },
  RateMode: {
    USD_TO_TARGET: '달러에서 대상 통화로',
    TARGET_TO_USD: '대상 통화에서 달러로',
  },
  PaymentOrderStatus: {
    FAILED: '처리 실패',
    SUCCESS: '처리 성공',
    PENDING: '처리 대기 중',
    CANCELED: '취소 완료',
    PROCESSING: '처리 중',
  },
  DepositPaymentOrderStatus: {
    FAILED: '충전 실패',
    SUCCESS: '충전 성공',
    PENDING: '처리 대기 중',
    CANCELED: '취소 완료',
    PROCESSING: '충전 중',
  },
  WithdrawPaymentOrderStatus: {
    FAILED: '출금 실패',
    SUCCESS: '출금 성공',
    PENDING: '처리 대기 중',
    CANCELED: '취소 완료',
    PROCESSING: '철회 진행 중',
  },
  PaySystemOrderStatus: {
    GATEWAY_CREATE: 'GATEWAY_CREATE',
    CONFIRM: 'CONFIRM',
    CANCEL: 'CANCEL',
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    CLOSE: 'CLOSE',
    FREEZE: 'FREEZE',
    WITHDRAWN: 'WITHDRAWN',
    NO_REFUND_OF_HANDLING_FEE: 'NO_REFUND_OF_HANDLING_FEE',
  },
  ProviderType: {
    APPLE: 'APPLE',
    GOOGLE: 'GOOGLE',
    FACEBOOK: 'FACEBOOK',
    PASSWORD: 'PASSWORD',
    MAIL_PASSWORD: 'MAIL',
    PHONE_PASSWORD: 'PHONE',
  },
  PaymentChannel: {
    INDIA_UPI_1: 'UPI 유형 1 (인도)',
    INDIA_NATIVE_1: '네이티브 유형 1 (인도)',
    INDIA_UPI_2: 'UPI 유형 2 (인도)',
    INDIA_NATIVE_2: '네이티브 유형 2 (인도)',
    BRAZIL_PIX_1: 'PIX 유형 1 (브라질)',
    BRAZIL_PIX_2: 'PIX 유형 2 (브라질)',
    BRAZIL_PIX_FAST: 'PIX 빠른 송금 (브라질)',
  },
  BankInfoExtType: {
    NORMAL: 'NORMAL',
    PIX_EXT: 'PIX_EXT',
    IFSC_EXT: 'IFSC_EXT',
    BANK_EXT: 'BANK_EXT',
    CRYPTO_CURRENCY_EXT: 'CRYPTO_CURRENCY_EXT',
  },
  PixType: {
    CPF: '개인 식별 번호',
    PHONE: '휴대폰 번호',
    EMAIL: '이메일 주소',
    EVP: '가상 결제 주소',
  },
  CryptoTokenType: {
    USDT_ERC20: 'USDT (ERC20)',
    USDT_TRC20: 'USDT (TRC20)',
    USDT_BEP20: 'USDT (BEP20)',
    ETHEREUM: 'Ethereum',
    BNB_BEP20: 'BNB (BEP20)',
    BTC: 'BTC',
    OTF_BEP20: 'OTF (BEP20)',
  },
  EpayCountryCode: {
    BR: '브라질',
  },
  EpayGender: {
    MALE: '남성',
    FEMALE: '여성',
  },
  EpayIdType: {
    ID_CARD: '신분증',
    PASSPORT: '여권',
  },
  EpayPurposeOfRemittance: {
    CorporatePayment: '법인결제',
    Marketplace: '시장 거래',
    ProfessionalServices: '전문 서비스',
    Payroll: '급여지급',
    ExpensesReimbursement: '비용 상환',
    RepresentationExpenses: '사업지불',
    ProfessionalServices2: '전문 서비스',
    HiredPersonnel: '고용된 사람',
    TraineesScholarships: '연수생/장학금',
    ProductivityOrQualityPrizes: '생산성 또는 품질 상',
    LayOffPayment: '해고 지급',
    FamilySupport: '가족 지원',
    Education: '교육',
    GiftAndOtherDonations: '선물 및 기타 기부',
    MedicalTreatment: '의학적 치료',
    MaintenanceOrOtherExpenses: '유지 관리 또는 기타 비용',
    CarDriver: '운전자',
    SoftwareLicense: '소프트웨어 라이센스',
    HotelAccommodation: '호텔 숙박',
    AdvertisingAndOrPublicRelationsRelatedExpenses: '광고 및/또는 홍보 관련 비용',
    FeesForAdvisoryOrConsultingService: '컨설팅 또는 컨설팅 서비스 수수료',
    BusinessRelatedInsurancePayment: '비즈니스 관련 보험금 지급',
    InsuranceClaimsPayment: '보험금 청구서 지급',
  },
  Gender: {
    MALE: '남성',
    FEMALE: '여성',
    UNKNOWN: '알 수 없음',
    NOT_APPLICABLE: '해당되지 않음',
  },
  BeneficiaryRelationShip: {
    BOYFRIEND: '남자친구',
    BUSINESS_PARTNER: '비즈니스 파트너',
    CHILDREN: '어린이',
    COLLEAGUE: '동료',
    EX_SPOUSE: '전 배우자',
    FIANCE: '미혼 남편',
    FIANCEES: '미혼 아내',
    FRIEND: '친구',
    GIRLFRIEND: '여자친구',
    GRAND_PARENTS: '조부모',
    PARENTS: '부모님',
    RELATIVE_UNCLE_AUNTIE_COUSIN: '친척/삼촌/아줌마/사촌',
    SELF: '자신',
    SIBLING_BROTHER_SISTER: '형제/형제/자매',
    SPOUSE: '배우자',
    SUBSIDIARY_COMPANY: '자회사',
  },
};
